export class ImageMapper {
  static mapArrayBufferToBlob(arrayBuffer) {
    return new Blob([arrayBuffer], { filename: 'image.jpg', type: 'image/jpeg' });
  }

  static async mapStreamToBlob(body) {
    let stream = await new Response(body);
    stream = await stream.blob();
    return stream;
  }

  static mapBlobToB64(blob) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });
  }

  static async mapArrayBufferToDataURL(arrayBuffer) {
    return ImageMapper.mapBlobToB64(await ImageMapper.mapArrayBufferToBlob(arrayBuffer));
  }

  static mapDataUrlToBlob(dataURI) {
    // convert base64 to raw binary data held in a string
    const byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const _ia = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      _ia[i] = byteString.charCodeAt(i);
    }

    const dataView = new DataView(arrayBuffer);
    const blob = new Blob([dataView], { type: mimeString });
    return blob;
  }

  static blobToArrayBuffer(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.addEventListener('loadend', () => {
        resolve(reader.result);
      });
      reader.addEventListener('error', reject);
      reader.readAsArrayBuffer(blob);
    });
  }

  static async base64ToBlob(base64) {
    let res = await fetch(base64);
    res = await res.blob();
    return res;
  }

  static async mapDataURLtoArrayBuffer(dataURL) {
    const byteString = atob(dataURL.split(',')[1]);
    return new ArrayBuffer(byteString.length);
    // return await ImageMapper.blobToArrayBuffer(ImageMapper.mapDataUrlToBlob(dataURL));
  }
}
